export function userCanShare() {
	if(!window.UserId){
		return true;
	}
	if(window.userLevels['1563130796'] && window.userLevels['1563130796'].Active){
		return true;
	}
	if(parseInt(window.userData.registration_coupon)){
		return true;
	}
	return false;
}
(function ($) {
	window.removeGloop = function (gloopOptions) {
		let gloopClass = `#draft-item-${gloopOptions}`;
		$(gloopClass).remove();
	};
})(jQuery);